export default __webpack_public_path__ + "static/media/amexcard.16e2f1c6.svg";